import { forwardRef } from "react";
import type { JSX } from "react";
import type { DetectedObject } from "./types";
import { boxToRectPercent } from "./geometry";

const ACTIVE = "#FFD400";
const IDLE = "#00E0FF";

/** Dev overlay drawing detection boxes. The parent positions THIS container
 *  (left/top/width/height + transform) imperatively via the forwarded ref so
 *  the boxes track the photo's object-contain rect and smart-zoom transform. */
export const DebugBoxes = forwardRef<
  HTMLDivElement,
  { objects: DetectedObject[]; activeIndex: number | null }
>(function DebugBoxes({ objects, activeIndex }, ref): JSX.Element {
  return (
    <div
      ref={ref}
      data-testid="debug-boxes"
      className="pointer-events-none absolute left-0 top-0"
      style={{ transformOrigin: "center center" }}
    >
      {objects.map((o, i) => {
        const r = boxToRectPercent(o.box_2d);
        const color = i === activeIndex ? ACTIVE : IDLE;
        return (
          <div
            key={i}
            data-testid="debug-box"
            style={{
              position: "absolute",
              left: `${r.left}%`,
              top: `${r.top}%`,
              width: `${r.width}%`,
              height: `${r.height}%`,
              border: `2px solid ${color}`,
              boxSizing: "border-box",
            }}
          >
            <span
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                transform: "translateY(-100%)",
                font: "600 11px/1.2 ui-monospace, monospace",
                color,
                background: "rgba(0,0,0,0.65)",
                padding: "1px 4px",
                whiteSpace: "nowrap",
              }}
            >
              {o.label} {Math.round(o.confidence * 100)}%
            </span>
          </div>
        );
      })}
    </div>
  );
});
